<template>
	<div class="wrap">
		<!-- header -->
		<el-row type="flex" justify="space-between" align="middle">
			<el-col :span="6" style="display: flex;align-items: center;">
				<span style="font-weight: bolder;margin-right: 12px;font-size: 20px;">{{
					$t("certificate.stationName")
				}}</span>
				<el-button type="primary" size="mini" @click="handlerDeleteAll">{{
					$t("certificate.delAll")
				}}</el-button>
			</el-col>
			<!-- search -->
			<el-col :span="18">
				<div style="float: right;display: flex;align-items: center;">
					<el-input
						size="small"
						style="width: 200px;margin-right: 10px;"
						v-model="search.userName"
						:placeholder="$t('certificate.pUserAccount')"
						clearable
					></el-input>
					<el-input
						size="small"
						style="width: 200px;margin-right: 10px;"
						v-model="search.nickName"
						:placeholder="$t('certificate.pUsername')"
						clearable
					></el-input>
					<el-input
						size="small"
						style="width: 200px;margin-right: 10px;"
						v-model="search.equipmentNo"
						:placeholder="$t('certificate.pEnterMachineNo')"
						clearable
					></el-input>
					<el-date-picker
						type="datetimerange"
						value-format="yyyy-MM-dd HH:mm:ss"
						style="width: 280px;margin-right: 10px;"
						size="small"
						v-model="search.time"
						:range-separator="$t('certificate.to')"
						:start-placeholder="$t('certificate.sTime')"
						:end-placeholder="$t('certificate.eTime')"
					>
					</el-date-picker>
					<el-button
						type="primary"
						icon="el-icon-search"
						size="small"
						@click="handlerSearch"
						>{{ $t("certificate.search") }}</el-button
					>
					<el-button
						icon="el-icon-refresh"
						size="small"
						@click="handlerReset"
						>{{ $t("certificate.reset") }}</el-button
					>
				</div>
			</el-col>
		</el-row>
		<!-- main -->
		<el-row class="main" :gutter="20" v-loading="loading">
			<el-col :span="6" v-for="item in info" :key="item.id">
				<div
					class="card"
					style="background-color: #f6f6f6;border-radius: 2%;padding: 15px;box-sizing: border-box;"
				>
					<el-carousel
						:interval="10000"
						height="230px"
						style="cursor:pointer;border-radius: 4px;"
					>
						<el-carousel-item
							v-for="(ite, idx) in item.item"
							:key="ite.id"
							style="display: flex;align-items: center;"
						>
							<el-image
								style="transform: rotate(180deg);"
								@click="handlerPreview(item.item)"
								fit="contain"
								:src="ite.img"
							>
							</el-image>
						</el-carousel-item>
					</el-carousel>
					<!-- 设备编号 -->
					<div style="line-height: 1.2;margin: 16px 0 4px;font-weight: bold;">
						{{ $t("certificate.equipmentNo") }}
						:{{ item.equipmentNo || "" }}
					</div>
					<div style="line-height: 1.2;">
						{{ item.createTime || item.updateDate || "" }}
						<span
							style="float: right;color: red;margin-right: 2%; cursor: pointer;"
							><i @click="handlerDelItem(item)" class="el-icon-delete"></i
						></span>
					</div>
				</div>
			</el-col>
		</el-row>
		<!-- fenye -->
		<el-row v-if="info.length > 0">
			<el-pagination
				background
				layout="prev, pager, next"
				:total="+page.totalSize"
				:page-size="+page.pageSize"
				@current-change="handlerCurrentChange"
			>
			</el-pagination>
		</el-row>
		<el-row v-if="info.length <= 0 && loading == false">
			<div style="text-align: center;margin-top: 20px;color: #999;">
				{{ $t("certificate.nowNotHaveData") }}
			</div>
		</el-row>
		<el-image-viewer
			v-if="imgViewerVisible"
			:on-close="closeImgViewer"
			:url-list="preList"
			:initialIndex="initialIndex"
			:defaultDeg="180"
		/>
	</div>
</template>

<script>
// 从 element-ui 源码导入 ImageViewer 组件
import ImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
	components: {
		"el-image-viewer": ImageViewer,
	},
	data() {
		return {
			loading: false,
			imgViewerVisible: false,
			initialIndex: 0,
			info: [],
			search: {
				equipmentNo: "",
				time: "",
				startTime: "",
				endTime: "",
				userName: "",
				nickName: "",
			},
			page: {
				pageSize: 8,
				pageIndex: 1,
				totalSize: 0,
			},
			preList: [],
		};
	},
	created() {},
	mounted() {
		this.getList();
	},
	methods: {
		handlerDelItem(item) {
			this.$confirm(
				this.$t("certificate.confirmDelItem"),
				this.$t("certificate.tips"),
				{
					confirmButtonText: this.$t("certificate.continue"),
					cancelButtonText: this.$t("certificate.cancel"),
					type: "warning",
				}
			).then(() => {
				let arr = [];
				arr.push(item.id);
				this.$api
					.request(
						this.$url.TemporaryStorageCertificate.del,
						this.$method.delete,
						{
							ids: arr,
						}
					)
					.then(res => {
						if (res.code === 0) {
							this.getList();
							this.$message({
								message: res.msg,
								type: "success",
							});
						}
					});
			});
		},
		handlerDeleteAll() {
			this.$confirm(
				this.$t("certificate.confirmDel"),
				this.$t("certificate.tips"),
				{
					confirmButtonText: this.$t("certificate.continue"),
					cancelButtonText: this.$t("certificate.cancel"),
					type: "warning",
				}
			).then(() => {
				let arr = [];
				for (let i = 0; i < this.info.length; i++) {
					arr.push(this.info[i].id);
				}
				this.$api
					.request(
						this.$url.TemporaryStorageCertificate.del,
						this.$method.delete,
						{
							ids: arr,
						}
					)
					.then(res => {
						if (res.code === 0) {
							this.getList();
							this.$message({
								message: res.msg,
								type: "success",
							});
						}
					});
			});
		},
		closeImgViewer() {
			this.imgViewerVisible = false;
		},
		handlerPreview(imgs) {
			if (imgs.length > 0) {
				this.imgViewerVisible = true;
				this.preList = [];
				imgs.forEach(item => {
					this.preList.push(item.img);
				});
			} else {
				this.preList = [];
			}
		},
		handlerReset() {
			this.search = {
				equipmentNo: "",
				time: "",
				startTime: "",
				endTime: "",
				userName: "",
				nickName: "",
			};
		},
		handlerSearch() {
			this.getList();
		},
		// 分页
		handlerCurrentChange(e) {
			this.page.pageIndex = e;
			this.getList();
		},
		// 获取活动列表
		getList(current) {
			this.loading = true;

			current && (this.page.pageIndex = current);
			this.loading = true;
			let obj = {
				type: this.activityType,
				pageIndex: current || this.page.pageIndex,
				pageSize: this.page.pageSize,
			};
			if (this.search.equipmentNo) {
				obj.equipmentNo = this.search.equipmentNo;
			}
			if (this.search.time) {
				obj.startTime = this.search.time[0];
				obj.endTime = this.search.time[1];
			}
			if (this.search.userName) {
				obj.userName = this.search.userName;
			}
			if (this.search.nickName) {
				obj.nickName = this.search.nickName;
			}
			this.$api
				.request(
					this.$url.TemporaryStorageCertificate.list,
					this.$method.get,
					obj
				)
				.then(res => {
					this.loading = false;
					if (res.code === 0) {
						this.info = res.data.records;
						this.page.totalSize = res.data.total;
					} else {
						this.$message.warning(res.msg);
					}
					this.loading = false;
				});
		},
	},
};
</script>
<style scoped lang="scss">
.wrap {
	padding: 14px 20px;
	.main {
		margin-bottom: 0;
		.el-col {
			margin: 14px 0;
		}
	}
	.el-pagination {
		margin-top: 6px;
	}
	.card {
		transition: 0.6s;
	}
	.card:hover {
		box-shadow: 10px 10px 10px #eee;
	}
}
</style>
